import type { ReactElement } from "react";

import { InclusionFilterResult } from "app/pages/sales-intelligence/common-components/filters-panel/components/InclusionFilterResult/InclusionFilterResult";
import {
    getTechnologyConditionKey,
    hasSameTechnologyObject,
} from "app/pages/sales-intelligence/domain/technology/utils/operations";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import type FindTechnologyFilter from "app/pages/sales-intelligence/modules/leads-search-filters/models/TechnologyFilter/TechnologyFilter";
import InclusionTechnologiesChip from "app/pages/sales-intelligence/modules/technology/components/InclusionTechnologiesChip/InclusionTechnologiesChip";
import { TechnologyModal } from "app/pages/sales-intelligence/modules/technology/components/modals/TechnologyModal/TechnologyModal";

export const TechnologyFilterResult = ({
    filter,
    value = [],
    isActionEnabled = true,
    onGetLifecycleStatus,
    onFilterUpdate,
    onFilterValueRemove,
}: IFilterViewBaseProps<FindTechnologyFilter>): ReactElement | null => {
    const { options } = filter;

    return (
        <InclusionFilterResult
            value={value}
            isActionEnabled={isActionEnabled}
            onGetLifecycleStatus={onGetLifecycleStatus}
            onFilterUpdate={onFilterUpdate}
            onFilterValueRemove={onFilterValueRemove}
            hasSameObject={hasSameTechnologyObject}
            getConditionKey={getTechnologyConditionKey}
            renderModal={({ isOpen, selectedItem, onClose, onCancel, onApply }) => (
                <TechnologyModal
                    isOpen={isOpen}
                    selected={selectedItem}
                    onClose={onClose}
                    onCancel={onCancel}
                    onApply={onApply}
                    options={options}
                    value={value}
                    isExcludeAvailable={filter.isExcludeInclusionAvailable(value, selectedItem)}
                />
            )}
            renderChip={({ item, hideActionButton, onEdit, onDelete }) => (
                <InclusionTechnologiesChip
                    item={item}
                    hideActionButton={hideActionButton}
                    onEdit={onEdit}
                    onDelete={onDelete}
                />
            )}
        />
    );
};
